import { GoogleMapsAPIWrapper } from '@agm/core';
import { Directive, Input, Output, TemplateRef, ContentChild, ElementRef } from '@angular/core';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';

declare class ModifiedOverlayView extends google.maps.OverlayView {
  mapDiv?: Element;
  menuItems?: any;
  isVisible?: boolean;
  hide?: () => void;
  show?: (_: any) => void;
}

@Directive({
  selector: 'agm-map-context-menu',
})
export class ContextMenuMapDirective {
  private contextMenu: any;

  public lng: number;
  public lat: number;

  @ContentChild('contextMenuContent')
  public contextMenuContent: ElementRef;

  constructor(
    private gmapsApi: GoogleMapsAPIWrapper,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.Initialize();
  }

  CreateContextMenu(map, options) {
    var menu: ModifiedOverlayView = new google.maps.OverlayView();
    options = options || {};
    menu.setMap(map);
    menu.mapDiv = map.getDiv();
    menu.menuItems = options.menuItems || {};
    menu.isVisible = false;
    var that = this;
    menu.onAdd = function () {
      var divOuter = document.createElement('div');

      divOuter.style.borderStyle = 'none';
      divOuter.style.borderWidth = '0px';
      divOuter.style.position = 'absolute';
      divOuter.style.visibility = 'hidden';
      divOuter.style.background = 'white';
      divOuter.style.opacity = '0.85';
      divOuter.style.padding = '5px';

      if (that.contextMenuContent) {
        divOuter.appendChild(that.contextMenuContent.nativeElement);
      }

      this.div_ = divOuter;

      var panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.div_);
    };

    menu.draw = function () {
      var div = this.div_;
      div.style.left = '0px';
      div.style.top = '0px';
    };

    menu.onRemove = function () {
      this.div_.parentNode.removeChild(this.div_);
      this.div_ = null;
    };

    menu.hide = function () {
      if (this.div_) {
        // The visibility property must be a string enclosed in quotes.
        this.div_.style.visibility = 'hidden';
      }
    };

    menu.show = function (cpx) {
      if (this.div_) {
        var div = this.div_;
        div.style.left = cpx.x + 'px';
        div.style.top = cpx.y + 'px';
        this.div_.style.visibility = 'visible';
      }
    };

    return menu;
  }

  HideContexMenu() {
    if (this.contextMenu) {
      this.contextMenu.hide();
    }
  }

  Initialize() {
    this.gmapsApi.getNativeMap().then((map) => {
      this.setupMapListeners(map);
    });
  }

  setupMapListeners(map) {
    if (this.contextMenu) {
      this.contextMenu.setMap(null);
      this.contextMenu = null;
    }

    this.contextMenu = this.CreateContextMenu(map, {});
    this.contextMenu.hide();

    google.maps.event.clearListeners(map, 'rightclick');
    google.maps.event.addListener(map, 'rightclick', (mouseEvent) => {
      this.contextMenu.hide();
      const overlayProjection = this.contextMenu.getProjection();
      const cpx = overlayProjection.fromLatLngToDivPixel(mouseEvent.latLng);

      this.lng = parseFloat(mouseEvent.latLng.lng().toFixed(4));
      this.lat = parseFloat(mouseEvent.latLng.lat().toFixed(4));

      this.contextMenu.show(cpx);

      map.setOptions({ draggableCursor: 'pointer' });
    });

    google.maps.event.addListener(map, 'click', () => {
      this.contextMenu.hide();
    });

    this.googleAnalyticsService.eventEmitter(
      'initialize_map',
      'location_services',
      'get_native_map',
    );
  }
}
